import type { FC } from "react"

import { AttachFilesDialog } from "@/components/upload/AttachFilesDialog/AttachFilesDialog"
import { ReferenceTableName } from "@/graphql/codegen/graphql"
import { PURCHASE_ORDER_FILE_TYPE_TO_LABEL } from "@/screens/Procurement/PurchaseOrder/constants"
import type { Option } from "@/types/form-fields"

const purchaseOrderFileTypeOptions: Option<string>[] = Array.from(
  PURCHASE_ORDER_FILE_TYPE_TO_LABEL,
  ([value, label]) => ({ value, label })
)

interface PurchaseOrderFileDialogProps {
  onClose: () => void
  onSuccess: () => void
  orderId: string
  isQuote?: boolean
}

export const PurchaseOrderFileDialog: FC<PurchaseOrderFileDialogProps> = ({
  onClose,
  onSuccess,
  orderId,
  isQuote = false,
}) => (
  <AttachFilesDialog
    title={isQuote ? "Attach File to Quote" : "Attach File to PO"}
    referenceTableName={ReferenceTableName.Order}
    referenceId={orderId}
    documentTypeOptions={purchaseOrderFileTypeOptions}
    successMessage='Purchase order files attached'
    testIdPrefix='purchase-order-file'
    dialogTestId='purchase-order-file-dialog'
    onClose={onClose}
    onSuccess={onSuccess}
  />
)
